import React from 'react';
import { useLocation } from 'react-router-dom';

const Footer = () => {
  const location = useLocation();
  if (location.pathname.includes('/evaluate/')) return null;

  return (
    <footer className="app-footer">
      <a href="https://ricardotxr.pt" target="_blank" rel="noopener noreferrer">
        ricardotxr.pt
      </a>
    </footer>
  );
};

export default Footer;
